<template>
    <div class="p-6 bg-gray-100 min-h-screen">
      <h1 class="text-2xl font-bold mb-4">Claves Pendientes</h1>
      <div class="flex gap-4 mb-6">
        <button 
          class="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
          :class="{ 'bg-gray-500 hover:bg-gray-600': filtros.sin_token_final }"
          @click="toggleFilter('sin_token_final')">
          Mostrar Sin Token Final
        </button>
        <button 
          class="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600"
          :class="{ 'bg-gray-500 hover:bg-gray-600': filtros.con_token_final }"
          @click="toggleFilter('con_token_final')">
          Mostrar Con Token Final
        </button>
        <button 
          class="bg-yellow-500 text-white px-4 py-2 rounded hover:bg-yellow-600"
          :class="{ 'bg-gray-500 hover:bg-gray-600': filtros.ordenar_por_fecha === 'asc' }"
          @click="toggleFilter('ordenar_por_fecha', 'asc')">
          Ordenar por Fecha Ascendente
        </button>
        <button 
          class="bg-yellow-500 text-white px-4 py-2 rounded hover:bg-yellow-600"
          :class="{ 'bg-gray-500 hover:bg-gray-600': filtros.ordenar_por_fecha === 'desc' }"
          @click="toggleFilter('ordenar_por_fecha', 'desc')">
          Ordenar por Fecha Descendente
        </button>
      </div>
  
      <div class="mb-4">
        <p class="text-gray-700">Registros visibles: <span class="font-bold">{{ registros.length }}</span></p>
      </div>
  
      <table class="table-auto w-full bg-white shadow rounded-lg">
        <thead class="bg-gray-200">
          <tr>
            <th class="px-4 py-2">ID</th>
            <th class="px-4 py-2">Clave Pendiente</th>
            <th class="px-4 py-2">Token Final</th>
            <th class="px-4 py-2">Veces Consultado</th>
            <th class="px-4 py-2">Consultado</th>
            <th class="px-4 py-2">Terminado</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="registro in registros" :key="registro.id_clave_pendiente">
            <td class="border px-4 py-2">{{ registro.id_clave_pendiente }}</td>
            <td class="border px-4 py-2">{{ registro.clave_pendiente }}</td>
            <td class="border px-4 py-2">{{ registro.token_final || 'N/A' }}</td>
            <td class="border px-4 py-2">{{ registro.veces_consultado }}</td>
            <td class="border px-4 py-2">{{ registro.consultado }}</td>
            <td class="border px-4 py-2">{{ registro.terminado || 'N/A' }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </template>
  
  <script>
  import axios from 'axios';
  
  export default {
    data() {
      return {
        registros: [],
        filtros: {
          sin_token_final: false,
          con_token_final: false,
          ordenar_por_fecha: null, // Puede ser 'asc' o 'desc'
        },
      };
    },
    methods: {
      async fetchData() {
        try {
          const params = {};
          if (this.filtros.sin_token_final) params.sin_token_final = true;
          if (this.filtros.con_token_final) params.con_token_final = true;
          if (this.filtros.ordenar_por_fecha) params.ordenar_por_fecha = this.filtros.ordenar_por_fecha;
  
          const { data } = await axios.get('/api/claves-pendientes/obtener', { params });
          this.registros = data.data;
        } catch (error) {
          console.error('Error al obtener los registros:', error);
        }
      },
      toggleFilter(filter, value = null) {
        if (filter === 'ordenar_por_fecha') {
          // Si el filtro actual es el mismo, lo desactiva
          this.filtros[filter] = this.filtros[filter] === value ? null : value;
        } else {
          // Para otros filtros, actúa como toggle
          this.filtros[filter] = !this.filtros[filter];
  
          // Si activamos "sin_token_final", desactivamos "con_token_final" y viceversa
          if (filter === 'sin_token_final' && this.filtros[filter]) {
            this.filtros.con_token_final = false;
          } else if (filter === 'con_token_final' && this.filtros[filter]) {
            this.filtros.sin_token_final = false;
          }
        }
  
        // Refrescar los datos
        this.fetchData();
      },
    },
    mounted() {
      this.fetchData();
    },
  };
  </script>
  
  <style scoped>
  /* Puedes agregar estilos personalizados aquí si es necesario */
  </style>
  